<template>
<!-- <ProOptionWrapper :featureName="'calendarView'"> -->
  <div class="content-form__switch-field">

    <div class="content-form__switcher-wrap">
      <div class="content-form__switcher-label">
        Calendar view
      </div>
      <label
        :class="{ 'selected': calendarState.enabled }"
        class="switcher"
      >
        <input
          v-model="calendarState.enabled"
          class="switcher__input"
          type="checkbox"
          value="tiles"
          @change="$trackFeature('content', 'calendarView', calendarState.enabled)"
        >
        <span class="switcher__indicator"></span>
      </label>
    </div>

    <div v-if="calendarState.enabled" class="content-form__switch-hidden-field aside-select paddingless">
      <div class="content-form__highlighted">
        <FormField
          label="Date column"
          class="side-form__item aside-input">
          <v-select
            v-model="calendarState.startDateColId"
            :items="cols"
            item-text="label"
            item-value="id"
            menu-props="offsetY"
            placeholder="Date column"
            append-icon="keyboard_arrow_down"
          >
          </v-select>
          <a class="sorting-constructor__link" target="_blank" href="https://help.spreadsimple.com/en/article/setting-up-calendar-view-x2bb69/">Help: How to set up Calendar view?</a>
        </FormField>
        <FormField
          label="Default view"
          class="side-form__item aside-input">
            <v-select
              :value="mapViewState.defaultView"
              :items="typeOptions"
              item-text="label"
              item-value="value"
              menu-props="offsetY"
              placeholder="Default view"
              append-icon="keyboard_arrow_down"
              @change="onChangeDefaultView"
            >
            </v-select>
        </FormField>
        <FormField
          label="Week starts on"
          class="side-form__item aside-input">
          <v-select
            v-model="calendarState.weekStartsOn"
            :items="weekStartsOnOptions"
            item-text="label"
            item-value="value"
            menu-props="offsetY"
            placeholder="Week starts on"
            append-icon="keyboard_arrow_down"
          >
          </v-select>
        </FormField>
      </div>
    </div>
  </div>
<!-- </ProOptionWrapper> -->
</template>
<script>
import FormField from '@/components/form-field'
// import ProOptionWrapper from '@/components/pro-option-wrapper'
import { markerTypes, setViewTypeList } from '@/modules/utils/mapOptions'
export default {
  name: 'CalendarViewConstructor',
  markerTypes,
  setViewTypeList,
  components: {
    // ProOptionWrapper,
    FormField
  },
  props: {
    cols: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    mapViewState: {
      type: Object
    }
  },
  data () {
    return {
      calendarState: null,
      weekStartsOnOptions: [
        { label: 'Monday', value: 'monday' },
        { label: 'Sunday', value: 'sunday' }
      ]
    }
  },
  computed: {
    typeOptions () {
      return this.$options.setViewTypeList(this.mapViewState?.enabled, this.calendarState.enabled)
    }
  },
  watch: {
    calendarState: {
      deep: true,
      handler: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChangeDefaultView (val) {
      this.$emit('default-view-change', val)
    }
  },
  created () {
    this.calendarState = JSON.parse(JSON.stringify(this.value))
    if (!this.calendarState.weekStartsOn) {
      this.calendarState.weekStartsOn = 'monday'
    }
  }
}
</script>
